module.exports = __webpack_public_path__ + "static/media/groundmeat.f0397723.jpeg";